
export enum DwellReasonTypeCd {
	ACTIVE = 'Active',
	ALL = 'All',
	INACTIVE = 'Inactive'}

